@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';
@import '../../respond-to.scss';

$cart-icon-size: $spacing-32;
$cart-badge-size: $spacing-16;

:host {
  position: relative;
  width: 40px;
  height: 40px;
  a {
    height: 100%;
    width: 100%;
    align-items: center;
    display: flex;
    cursor: pointer;
    text-decoration: none;
  }
  .cart-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }
  .ciHeader-cart {
    &-count {
      cursor: pointer;
      font-size: $typography-button-small-size;
      position: absolute;
      color: $color-shade-white;
      background-color: $color-partnership-bold-default;
      border-radius: 50%;
      text-align: center;
      white-space: nowrap;
      height: $cart-badge-size;
      width: $cart-badge-size;
      line-height: $cart-badge-size;
      top: -8px;
      right: -8px;
    }
    &-icon-button {
      border-radius: 40px;
      display: flex;
      flex-direction: column;
      text-decoration: none;
      justify-content: center;
      @media (min-width: 700px) {
        gap: 8px;
        flex-direction: row;
      }
      span {
        font-size: var(--typography-button-small-size, 12px);
        color: #4a4a4a;
      }
      box-sizing: content-box;

      &:hover {
        border-radius: 50%;
        background-color: $color-header-hover-blue;
        svg, path {
          fill: $color-blue-default;
        }
      }

      &:active {
        border-radius: 50%;
        background-color: $color-header-hover-blue;
        svg, path {
          fill: $color-blue-default;
        }
      }
    }
  }
  ci-dialog::part(header) {
    @include breakpoint('md','lg','xl') {
      display: none;
    }
  }
  ci-dialog::part(content) {
    @include breakpoint('md','lg','xl') {
      padding: 8px 16px 16px 16px;
    }
  }
  ci-dialog::part(actions) {
      padding: 0;
  }
  .dialog-content {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    max-height: 45vh;
    @include breakpoint('md','lg','xl') {
      min-width: 400px;
      max-height: 250px;
      height: 250px;
    }
  }
  .cart-preview-empty {
    display: flex;
    padding-top: 24px;
    flex-direction: column;
    align-items: center;
    color: #444444;
    gap: var(--space-componentLayout-xs, 8px);
    span {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
    }
    @include breakpoint('md','lg','xl') {
      padding-top: 48px;
    }
  }
  .cart-preview-summary {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
    margin: 0 24px 16px 24px;
    font-size: 16px;
    font-style: normal;
    span {
      font-weight: 700;
      margin-left: 5px;
    }
    @include breakpoint('md','lg','xl') {
      margin: 0 16px 8px 16px;
    }
  }
  .cart-preview-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    &:empty {
      display: none;
    }
  }
  .cart-preview-design-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    h4 {
      font-weight: Bold;
      line-height: 1.25;
      letter-spacing: 0;
      font-family: $typography-family;
      margin: 0;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
    }
  }
  .cart-preview-item {
    &-content {
      -webkit-align-items: start;
      -webkit-box-align: start;
      -ms-flex-align: start;
      align-items: start;
      -webkit-column-gap: 16px;
      column-gap: 16px;
      display: grid;
      grid-template-columns: 33% auto;
      grid-template-rows: repeat(4, min-content) 1fr min-content;
      position: relative;
      row-gap: 4px;
      @include breakpoint('md','lg','xl') {
        grid-template-columns: 120px auto;
      }
    }
    &-product-name {
      grid-row: 1;
      margin: 0;
      font-weight: 500;
      font-size: 16px;
      line-height: 1.25;
      letter-spacing: 0;
      font-family: $typography-family;
      font-weight: 700;
      display: block;
      font-size: 16px;
      line-height: 1.25;
    }
    &-price {
      grid-column: 2 / 4;
      grid-row: 4;
      margin: 0;
      font-family: $typography-family;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
    }
    &-details {
      grid-column: 2 / 4;
      grid-row: 2;
      font-size: 14.4px;
      line-height: 1.25;
      display: flex;
      align-items: center;
      span {
        font-weight: 500;
        font-size: 16px;
        line-height: 1.25;
        letter-spacing: 0;
        font-family: $typography-family;
        display: -webkit-inline-box;
        display: -webkit-inline-flex;
        display: -ms-inline-flexbox;
        display: inline-flex
          ;
        margin-left: 8px;
        margin-right: 8px;
      }
    }
    &-quantity-with-price{
      grid-column: 2 / 4;
      grid-row: 3;
      font-weight: 500;
      font-size: 14px;
      line-height: 1.25;
      letter-spacing: 0;
      font-family: $typography-family;
      span {
        margin: 0;
        font-weight: 500;
        font-size: 14px;
        line-height: 1.25;
        letter-spacing: 0;
        font-family: $typography-family;
      }
    }
    &-sizes {
      grid-column: 2 / 4;
      grid-row: 4;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      gap: 4px;
      margin: 1px 0 1px -1px;
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-top: 2px;
        padding-bottom: 2px;;
        padding-left: 5px;
        padding-right: 5px;
        background-color: $color-gray-light;
        border-radius: 4px;
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
  .cart-preview-actions {
    display: flex;
    flex-direction: column;
    hr {
      display: block;
      border: 0;
      border-bottom: 1px solid $color-gray-accent;
      margin: 24px 0;
      width: 100%;
      @include breakpoint('md','lg','xl') {
        margin: 0 0 16px 0;
      }
    }
    button {
      @include pigment-button-primary();
      cursor: pointer;
      margin: 0 24px;
      @include breakpoint('md','lg','xl') {
        margin: 0 16px;
      }
    }
  }
}

@include breakpoint('lg','xl') {
  :host {
    padding-left: 0;

    .ciHeader-icon {
      margin-top: $spacing-8;
      margin-left: $spacing-8;
      padding: 0;
    }
  }
}
